import { getApi } from "@beeldit/core/helpers/api";

async function toExport(endpoint: string, filterPath: string = "") {
  return await getApi().post(`/${endpoint}/export?${filterPath}`);
}

export default toExport;
